<template>
  <section id="about" class="section about">
    <div class="container">
      <div class="section-head" v-reveal>
        <span class="eyebrow">01 / About</span>
        <h2 class="section-title">
          <span class="en">About</span>
          私たちについて
        </h2>
      </div>

      <div class="about__grid">
        <div class="about__prose">
          <p v-reveal="60">
            Advanced System House は、Webサービスにおけるバックエンドエンジニアリング——サーバー上で動くプログラムの開発や、インフラの構築・運用——を強みとする開発会社です。
          </p>
          <p v-reveal="120">
            さまざまなWebサービスの開発を手がけてきた技術者が、要件定義から運用保守までを一貫して担います。近年は、生成AIやAI駆動開発（Claude Code をはじめとするAIコーディング支援ツールの活用）を開発プロセスに取り入れ、これまで以上に速く、そして品質を落とさずにものづくりを進められる体制を整えてきました。
          </p>
          <p v-reveal="180">
            AIを「使うこと」自体が目的ではありません。お客様の課題を、確かに動くかたちにして届ける。そのための手段として、技術と経験、そしてAIを組み合わせています。
          </p>
          <p class="about__note" v-reveal="220">
            ※バックエンドエンジニアリングとは、WebサイトやWebサービスにおいて、主にサーバー上で動作するプログラムの開発や、サーバーの構築・運用などに関わる技術です。
          </p>
        </div>

        <aside class="profile" v-reveal="120" aria-label="会社概要">
          <div class="profile__head">
            <span class="profile__kicker">Company Profile</span>
            <span class="profile__tick" aria-hidden="true"></span>
          </div>
          <dl class="profile__list">
            <div class="profile__row">
              <dt>商号</dt>
              <dd>株式会社 Advanced System House</dd>
            </div>
            <div class="profile__row">
              <dt>創業</dt>
              <dd>2021年4月1日</dd>
            </div>
            <div class="profile__row">
              <dt>法人設立</dt>
              <dd>2023年1月11日</dd>
            </div>
            <div class="profile__row">
              <dt>所在地</dt>
              <dd>栃木県宇都宮市下戸祭1-3-11 904</dd>
            </div>
            <div class="profile__row">
              <dt>代表者</dt>
              <dd>代表取締役 桧山 聡</dd>
            </div>
            <div class="profile__row">
              <dt>事業内容</dt>
              <dd>
                <ul class="profile__biz">
                  <li>システム開発</li>
                  <li>WEBサイト制作</li>
                  <li>サーバー運用保守</li>
                  <li>ITコンサルティング</li>
                  <li>ITサポート</li>
                </ul>
              </dd>
            </div>
          </dl>
        </aside>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AboutSection',
}
</script>

<style scoped lang="scss">
.about__grid {
  display: grid;
  grid-template-columns: 1.2fr 0.8fr;
  gap: clamp(40px, 6vw, 88px);
  margin-top: clamp(40px, 6vw, 72px);
  align-items: start;
}

.about__prose {
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 56ch;

  p {
    font-size: clamp(1rem, 1.3vw, 1.12rem);
    line-height: 1.95;
    color: var(--ink-soft);
  }
}

.about__note {
  margin-top: 8px;
  padding-left: 18px;
  border-left: 2px solid var(--accent-line);
  font-size: 0.86rem !important;
  line-height: 1.8 !important;
  color: var(--ink-soft) !important;
}

/* --- Profile card --- */
.profile {
  position: sticky;
  top: calc(var(--header-h) + 28px);
  background: var(--paper-raised);
  border: 1px solid var(--line);
  border-radius: var(--radius-lg);
  padding: 8px 28px 12px;
  box-shadow: 0 30px 60px -46px rgba(20, 22, 27, 0.5);
}

.profile__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 0 16px;
  border-bottom: 1px solid var(--line);
}

.profile__kicker {
  font-family: var(--font-mono);
  font-size: 0.7rem;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--accent);
}

.profile__tick {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--accent);
  box-shadow: 0 0 0 4px var(--accent-mist);
}

.profile__row {
  display: grid;
  grid-template-columns: 88px 1fr;
  gap: 16px;
  padding: 16px 0;
  border-bottom: 1px solid var(--line-soft);

  &:last-child {
    border-bottom: 0;
  }
}

.profile__row dt {
  font-family: var(--font-mono);
  font-size: 0.74rem;
  letter-spacing: 0.04em;
  color: var(--muted);
  padding-top: 2px;
}

.profile__row dd {
  font-size: 0.94rem;
  line-height: 1.6;
  color: var(--ink);
}

.profile__biz {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.profile__biz li {
  position: relative;
  padding-left: 16px;
}

.profile__biz li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0.62em;
  width: 6px;
  height: 6px;
  background: var(--accent);
  transform: rotate(45deg);
}

@media (max-width: 900px) {
  .about__grid {
    grid-template-columns: 1fr;
  }
  .profile {
    position: static;
  }
}
</style>
